import { SEPARATOR } from '../shared/constants';

export function formatLocationIdParam(locationId: number[]): string {
  return locationId.join(SEPARATOR);
}

export function formatPersonProfileIdParam(
  personProfileId?: string[]
): string | undefined {
  if (!personProfileId || personProfileId.length === 0) return undefined;

  return personProfileId.join(SEPARATOR);
}

export function getSearchParams(
  locationId: number[],
  searchParams = '',
  personProfileId?: string[]
): string {
  const params = new URLSearchParams();

  const locationIdsParam = formatLocationIdParam(locationId);
  params.append('locationIds', locationIdsParam);

  if (personProfileId && personProfileId.length > 0) {
    const personProfileIdParam = formatPersonProfileIdParam(personProfileId);
    if (personProfileIdParam) {
      params.append('personProfileId', personProfileIdParam);
    }
  }

  if (searchParams) {
    const searchParamsObj = new URLSearchParams(searchParams);
    searchParamsObj.forEach((value, key) => {
      params.set(key, value);
    });
  }

  return params.toString();
}
